import { useState } from "react";

export default function PasswordModal({
  open,
  password,
  setPassword,
  onSubmit,
  error,
  loading,
  setPasswordError,
  primaryColor,
  primaryFontColor = "#fff"
}) {
  const [isFocused, setIsFocused] = useState(false);


  if (!open) return null;
  return (
    <div className="pm-overlay">
      <div className={`pm-card ${error ? "pm-error-shake" : ""}`}>
        <h3>Password Required</h3>

        <input
          type="password"
          value={password || ""}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onChange={(e) => {
            setPassword(e.target.value);
            setPasswordError("");
            }}
            style={{}}
          placeholder="Enter password"
          autoFocus
          onKeyDown={(e) => e.key === "Enter" && onSubmit()}
          style={{
              border: `2px solid ${isFocused ? primaryColor : '#d9d9d9'}`,
              outline: 'none',
          }}
        />

        {error && <div className="pm-error">{error}</div>}

        <button style={{backgroundColor:primaryColor,color:primaryFontColor}} disabled={loading} onClick={onSubmit}>
            {loading ? <span className="loader"></span> : "OK"}
        </button>
      </div>
    </div>
  );
}